// Routes de l'option « Bons d'intervention » (sous la section Interventions). Option inactive : les pages répondent « introuvable ».
import type { RouteObject } from 'react-router';
import '../../styles/interventions.css';
import '../../styles/chantiers.css';
import '../../styles/bons.css';
import { PageBons } from './PageBons.tsx';
import { PageBon } from './PageBon.tsx';
import { PageFluides } from './fluides.tsx';

export const routesBons: RouteObject[] = [
  { path: 'interventions/bons', element: <PageBons /> },
  { path: 'interventions/bons/fluides', element: <PageFluides /> },
  { path: 'interventions/bons/:id', element: <PageBon /> },
];
